// extracted by mini-css-extract-plugin
export default {"infosOrga":"OWT3LnTk9kPkNZcqSRo3","right":"olQ4Ml9f9KkfZejZTE2g","left":"Iu9gznVdVQyqAW2qsNxS"};